import { DatePipe } from '@angular/common';
import { Component, Inject } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialog } from '@angular/material/dialog';
import { MatTableDataSource } from '@angular/material/table';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { ReplaySubject, Subject, takeUntil } from 'rxjs';
import { ApiUrlHelper } from 'src/app/common/api-url-helper';
import { dateformat, host } from 'src/app/models/commonModel';
import { CommonService } from 'src/app/services/common/common.service';
import { ConfirmFreezeComponent } from '../confirm-freeze/confirm-freeze.component';
import { FreezeSessionLabelConstant } from 'src/app/constants/LabelConstants';

@Component({
    selector: 'app-freeze-session-dialog',
    templateUrl: './freeze-session-dialog.component.html',
    styleUrls: ['./freeze-session-dialog.component.scss'],
    standalone: false
})
export class FreezeSessionDialogComponent {

  minStartDate: Date = new Date();
  minEndDate: Date = new Date();
  minStartTime: any;
  minEndTime: any;
  freezeSessionForm: FormGroup;
  hostList: any = [];
  protected allHostlist: host[] = this.hostList;
  selectedHostId: any = [];
  selectedHostData: any = null;
  public hostCtrl: FormControl = new FormControl();
  protected filteredhost: ReplaySubject<any> = new ReplaySubject();
  protected _onDestroy = new Subject();
  showData: boolean = false;
  displayedColumns: string[] = [
    'HostedBy',
    'ClassName',
    'Date',
    'Time',
    'Participants',
  ];
  checkedValues: any[] = [];
  dataSource = new MatTableDataSource<any>([]);
  dateFormat: any;
  sessionList: any[] = [];
  labelConstant: any;
  submitted: boolean = false;

  constructor(
    private dialogRef: MatDialogRef<FreezeSessionDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private spinner: NgxSpinnerService,
    private api: ApiUrlHelper,
    private commonService: CommonService,
    private dialog: MatDialog,
    private toastr: ToastrService,
    public datePipe: DatePipe,
    private fb: FormBuilder) {
  }

  ngOnInit() {
    this.freezeSessionForm = this.fb.group({
      selectedHostId: ['', Validators.required],
      startDate: ['', Validators.required],
      startTime: ['', Validators.required],
      endDate: ['', Validators.required],
      endTime: ['', Validators.required],
    });
    this.labelConstant = FreezeSessionLabelConstant;
    this.dateFormat = dateformat;
    this.filteredhost.next(this.allHostlist.slice());
    this.hostCtrl.valueChanges.pipe(takeUntil(this._onDestroy)).subscribe(() => {
      this.filterHost();
    });
    this.fetchHostList();
  }


  getInstructorNameById(id: number): string {
    const instructor = this.allHostlist.find(customer => customer.userId === id);
    return instructor ? instructor.fullName : '';
  }

  get selectedInstructorNames(): string {
    if (this.selectedHostId.length > 0) {
      return this.selectedHostId
        .map(id => this.getInstructorNameById(id))
        .join(', ');
    }
    else {
      return '';
    }
  }

  startDateChange() {
    this.freezeSessionForm.patchValue({
      startTime: null
    });
    if (this.freezeSessionForm.value.startDate > this.freezeSessionForm.value.endDate) {
      this.freezeSessionForm.patchValue({
        endDate: null
      });
    }
    this.minEndDate = this.freezeSessionForm.value.startDate;

    if (this.datePipe.transform(this.freezeSessionForm.value.startDate, 'dd/MM/yyyy') == this.datePipe.transform(new Date(), 'dd/MM/yyyy')) {
      this.minStartTime = this.datePipe.transform(new Date(), 'hh:mm a');
    }
    else {
      this.minStartTime = null;
    }
    this.sessionList = [];
  }

  endDateChange() {
    this.freezeSessionForm.patchValue({
      endTime: null
    });

    if (this.datePipe.transform(this.freezeSessionForm.value.endDate, 'dd/MM/yyyy') == this.datePipe.transform(new Date(), 'dd/MM/yyyy')) {
      this.minEndTime = this.datePipe.transform(new Date(), 'hh:mm a');
    }
    else {
      this.minEndTime = null;
    }
    this.sessionList = [];
  }

  ngOnDestroy() {
    this._onDestroy.next(1);
    this._onDestroy.complete();
  }

  fetchHostList() {
    let api = this.api.apiUrl.Class.GetHostList.replace('{listType}', "false");
    this.spinner.show();
    this.commonService.doGet(api).pipe().subscribe({
      next: (response) => {
        if (response.success) {
          this.spinner.hide();
          this.allHostlist = response.data;
          this.filteredhost.next(this.allHostlist.slice());
        }
        else {
          this.spinner.hide();
          this.toastr.error(response.message);
        }
      }, error: (err) => {
        this.spinner.hide();
        console.log(err);
      }
    });
  }

  protected filterHost() {
    if (!this.allHostlist) {
      return;
    }
    let search = this.hostCtrl.value;
    if (!search) {
      this.filteredhost.next(this.allHostlist.slice());
      return;
    } else {
      search = search.toLowerCase();
    }
    this.filteredhost.next(
      this.allHostlist.filter(
        (data) => data.fullName.toLowerCase().indexOf(search) > -1
      )
    );
  }

  customerDropdownImageHandler(customer: any) {
    customer.hostImageUrl = '../../../assets/img/default-customer-profile.svg';
  }

  cancel() {
    this.dialogRef.close();
  }

  formatDate(dateString: string, timeString: string): string {
    const date = new Date(dateString);
    const timeParts = timeString.split(":");
    let hours = parseInt(timeParts[0]);
    const minutes = parseInt(timeParts[1].split(" ")[0]);
    const meridian = timeParts[1].split(" ")[1];
    if (meridian === "PM" && hours !== 12) {
      hours += 12;
    } else if (meridian === "AM" && hours === 12) {
      hours = 0;
    }
    date.setHours(hours, minutes);
    const localDate = new Date(date.getTime() - (date.getTimezoneOffset() * 60000));
    return localDate.toISOString();
  }

  search() {
    this.spinner.show();
    this.submitted = true;
    if (this.freezeSessionForm.invalid) {
      this.spinner.hide();
      return;
    }
    this.showData = false;
    let api = this.api.apiUrl.Class.GetFreezeUnFreeseSessionList;
    let obj = {
      HostIds: this.freezeSessionForm.value.selectedHostId ? this.freezeSessionForm.value.selectedHostId.join(",") : "",
      SessionStartDateTime: this.freezeSessionForm.value.startDate ? this.formatDate(this.freezeSessionForm.value.startDate, this.freezeSessionForm.value.startTime) : null,
      SessionEndDateTime: this.freezeSessionForm.value.endDate ? this.formatDate(this.freezeSessionForm.value.endDate, this.freezeSessionForm.value.endTime) : null,
      SessionFilter: false
    };
    this.commonService.doPost(api, obj).pipe().subscribe({
      next: (response) => {
        if (response.success) {
          this.showData = true;
          this.sessionList = response.data;
          this.dataSource = response.data;
          if (response.data.length <= 0) {
            this.toastr.error("No session record found for selected date and instructor(s).")
          }
        }
        this.spinner.hide();
      },
      error: (err) => {
        this.spinner.hide();
        console.log(err);
      }
    });
  }

  getClassSessionIds(): any {
    return this.sessionList.map(session => session.classSessionId).join(",");
  }

  hasParticipants(): boolean {
    return this.sessionList.some(session => session.participantCount > 0);
  }

  freezeSession(classSessionIds: any, hasParticipants: boolean) {
    const dialogRef = this.dialog.open(ConfirmFreezeComponent, {
      width: '550px',
      data: {
        hostIds: this.freezeSessionForm.value.selectedHostId ? this.freezeSessionForm.value.selectedHostId.join(",") : "",
        sessionStartDateTime: this.formatDate(this.freezeSessionForm.value.startDate, this.freezeSessionForm.value.startTime),
        sessionEndDateTime: this.formatDate(this.freezeSessionForm.value.endDate, this.freezeSessionForm.value.endTime),
        classSessionIds: classSessionIds,
        hasParticipants: hasParticipants
      },
      disableClose: true,
      autoFocus: false
    });
    dialogRef.afterClosed().subscribe((result) => {
    });
  }

  onInstructorChange(event: any) {
    this.sessionList = [];
  }

  onStartTimeChange(event: any) {
    this.sessionList = [];
  }

  onEndTimeChange(event: any) {
    this.sessionList = [];
  }
}